/**
 * ETA% summary for demo fixtures — keep in sync with
 * `zeecore/src/projections/orders-daily/summariseEtaFromDeliveries.ts`.
 */

import { ratioPercent } from '../lib/calc';
import type { OrdersDailyEtaProgress, OrdersDailyRow } from '../types/ordersDailyTruth';

function measure(rows: readonly OrdersDailyRow[]): { consignments: number; lifts: number } {
  const consignments = new Set(rows.map((r) => r.tracking_id));
  const lifts = rows.reduce((sum, r) => sum + (r.lifts ?? 0), 0);
  return { consignments: consignments.size, lifts };
}

export function summariseEtaFromDeliveries(
  deliveries: readonly OrdersDailyRow[],
): OrdersDailyEtaProgress {
  const eligible = deliveries.filter((r) => r.eta_on_time !== null && r.eta_on_time !== undefined);
  const onTime = eligible.filter((r) => r.eta_on_time === true);
  const late = eligible.filter((r) => r.eta_on_time === false);
  const total = measure(eligible);
  const on_time = measure(onTime);
  return {
    total,
    on_time,
    late: measure(late),
    completion_pct: ratioPercent(on_time.consignments, total.consignments),
  };
}
